// NotFound Component
import React from "react";
import { useHistory } from "react-router-dom";
import WhelenRImg from "../../assets/images/W-Red.svg";
import {
  FOOTER_ALL_RIGHTS_RESERVED,
  FOOTER_WHELEN,
  PAGE_NOT_FOUND_MSG,
  PAGE_NOT_FOUND_TITLE,
} from "../CommonConstants";

const NotFound = () => {
  const history = useHistory();
  const getYear = () => new Date().getFullYear();
  const handleBack = () => {
    history.push("/home");
  };

  return (
    <>
      <div className="not-found-page theme-dark">
        <div className="not-found-wrapper fluid-wrapper ">
          <img alt="Whelen" src={WhelenRImg} className="logo mb-4 pb-3" />
          <h1 className="not-found-title">{PAGE_NOT_FOUND_TITLE}</h1>
          <h4 className="not-found-message">{PAGE_NOT_FOUND_MSG}</h4>
          <button type="button" className="back-button btn btn-primary" onClick={handleBack}>
            <i className="fa fa-arrow-left left-arrow-icon" />
            BACK TO HOME
          </button>
        </div>
        <div className="not-found-footer">
          <footer className="footer">
            <div className="container">
              <div className="text-center">
                Copyright &copy;
                {getYear()}
                <a href="https://www.whelen.com/" rel="noreferrer" target="_blank" className="d-inline-block mx-2">
                  {FOOTER_WHELEN}
                </a>
                {FOOTER_ALL_RIGHTS_RESERVED}
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default NotFound;
